var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 7.875L52.5 19.6875V43.3125L31.5 55.125L10.5 43.3125V19.6875L31.5 7.875Z",
    stroke: "#2C3E50",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 31.5L52.5 19.6875",
    stroke: "#2C3E50",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 31.5V55.125",
    stroke: "#2C3E50",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 31.5L10.5 19.6875",
    stroke: "#2C3E50",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_28_612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 19.6875V43.3125L42 49.2188L31.5 55.125L21 49.2188L10.5 43.3125V19.6875L21 13.7812L31.5 7.875L42 13.7812L52.5 19.6875Z",
    stroke: "#2C3E50",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 31.5L42 25.5938L52.5 19.6875",
    stroke: "#2C3E50",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 31.5V55.125",
    stroke: "#2C3E50",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 31.5L21 25.5938L10.5 19.6875",
    stroke: "#2C3E50",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 31.5L42 36.75V49.2188",
    stroke: "#2C3E50",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 31.5L21 36.75V49.2188",
    stroke: "#2C3E50",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 13.7812L31.5 19.6875L42 13.7812",
    stroke: "#2C3E50",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_28_612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardIcon);
export default __webpack_public_path__ + "static/media/Standard_Icon.2ec66c9b1cbb099f6bdd06c775eafe8f.svg";
export { ForwardRef as ReactComponent };